import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { FetchPost } from "@/lib/fetch-helper";
import type { IUserCommunicationTemplate } from "@/src/common/UserCommunicationTemplate";
import { useQueryCustom } from "@/src/query-client-overrides";
import { urlFormat } from "@Components/Modules/Helpers";
import { Home } from "@Routes/HomepageLinks";
import { User } from "@Routes/UserLinks";

import type { IUserCommunicationTemplateModal } from "./UserCommunicationTemplateModal";
import UserCommunicationTemplateModal from "./UserCommunicationTemplateModal";

export const EmailConfirmationPage = () => {
    const { emailId } = useParams();
    const { data } = useQueryCustom({
        queryKey: ["emailConfirmation"],
        queryFn: async () =>
            FetchPost<IUserCommunicationTemplate>(
                urlFormat(User, { action: "SetValidateEmail", EmailChangeLogId: emailId }, true),
            ),
    });

    const navigate = useNavigate();
    const closeNavigationUrl = () => navigate(Home, { replace: true });

    if (!data) {
        return null;
    }

    const modalCustom: IUserCommunicationTemplateModal = {
        commBase: data,
        modal: {
            onClose: closeNavigationUrl,
        },
    };

    return <UserCommunicationTemplateModal {...modalCustom} />;
};
